export const CONCERTS_ID = [54, 82, 57];

const HIDDEN_LEAGUE_EVENT_NAME_FRAGMENT =
  '(includes tickets to all regular season home games)';

export const shouldHideLeagueEvent = (eventName?: string) =>
  eventName?.toLowerCase().includes(HIDDEN_LEAGUE_EVENT_NAME_FRAGMENT) ?? false;
